// extracted by mini-css-extract-plugin
module.exports = {"desktopNav":"e_on"};